import React, { useState, useEffect, useRef } from "react";
import DashboardNav from "../../Components/Navigation.js/Navigation";
import { LineChart, Line, ResponsiveContainer } from "recharts";
import Horheader from "../../Components/horheader/horheader";
import classes from "./AllInvoices.module.css";
import PdfIcon from "../../Asset/pdf.svg";
import Printer from "../../Asset/printer.png";
import xport from "../../Asset/export.png";
import verified from "../../Asset/tick-circle.png";
import crop from "../../Asset/repoort.png";
import search from "../../Asset/search.svg";
import UploadIcon from "../../Asset/upload.png";
import plus from "../../Asset/plus.png";
import Card from "../../Components/Card";
import Calender from "../../Asset/calendar.svg";
import agent from "../../Asset/agent.svg";
import { MdOutlineDownload } from "react-icons/md";
import {
  Spinner,
  Badge,
  Modal,
  Form,
  Tabs,
  Tab,
  Pagination,
  Placeholder,
  Accordion,
} from "react-bootstrap";
import PaidIcon from "../../Asset/completed.png";
import MoreIcon from "../../Asset/more.png";
import DownloadIcon from "../../Asset/download.png";
import TrackIcon from "../../Asset/track.png";
import NotPaidIcon from "../../Asset/Notpaid.png";
import Alert from "react-bootstrap/Alert";
import ContactIcon from "../../Asset/support.png";
import ViewIcon from "../../Asset/eye.png";
import InReviewIcon from "../../Asset/review.png";
import ReportIcon from "../../Asset/repoort.png";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { BASE_URL } from "../../API/Api";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TimeLineIcon from "../../Asset/timeline.png";
import TimeLineIcon2 from "../../Asset/timeline2.png";
import TimeLineIcon3 from "../../Asset/timeline3.png";
import notransaction from "../../Asset/no-transaction-icon.svg";
import FirstIcon from "../../Asset/totalApp.png";
import SecondIcon from "../../Asset/notpaidd.png";
import ThirdIcon from "../../Asset/inrevieww.png";
import FourthIcon from "../../Asset/comp.png";
import PaymentIcon from "../../Asset/payment.png";
import TickIcon from "../../Asset/tick-circle.png";
import BuildingIcon from "../../Asset/buildings.png";
import { Row, Col } from "react-bootstrap";
import ImageIcon from "../../Asset/piclogo.png";
import { Navbar, Container, Button } from "react-bootstrap";
// import localStorage from "@react-native-async-storage/async-storage";
import CurrencyInput from "react-currency-input-field";
import { useTheme } from "../../ThemeContext";
// import NewApplications from '../New Application/NewApplicationns';
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { LiaCheckCircle } from "react-icons/lia";
import OgsLogos from '../../Asset/ogsw-full.png';
// import axios from 'axios';
// import localStorage from '@react-native-async-storage/async-storage';

const Allinvoices = () => {
  const [taxStation, setTaxStation] = useState([]);
  const [location2, setLocation2] = useState([]);
  const [selectedStationName, setSelectedStationName] = useState("");
  const [documentValue, setDocumentValue] = useState("");
  const [selectedStation, setSelectedStation] = useState("");
  const [eyeClicked, setEyeClicked] = useState("");
  const [roleLoading, setRoleLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const [selectedLocationName, setSelectedLocationName] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [schemes, setSchemes] = useState([]);
  const [showAllocation, setShowAllocation] = useState(false);
  const [selectedSource, setSelectedSource] = useState("");
  const [tableArea, setTableArea] = useState([]);
  const [selectedNature, setSelectedNature] = useState("");
  const [allLands, setAllLands] = useState([]);
  const [selectedConsent, setSelectedConsent] = useState("");
  const [consentTypes, setConsentTypes] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedLandStatus, setSelectedLandStatus] = useState("");
  const [selectedAreaName, setSelectedAreaName] = useState("");
  const [tableData32, setTableData32] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [volumeNumber1, setVolumeNumber1] = useState("");
  const [pageNumber1, setPageNumber1] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showRatification, setShowRatification] = useState(false);
  const [showCFO, setShowCFO] = useState(false);
  const [showLand, setShowLand] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [cofoNumber, setCofONumber] = useState("");
  const [proposedRBuilding, setProposedRBuilding] = useState("");
  const [otherProperty, setOtherProperty] = useState("");
  const [plotSize, setPlotSize] = useState("");
  const [tenant, setTenant] = useState("");
  const [sqm, setSqm] = useState("");
  const [valueProperty, setValueProperty] = useState("");
  const [timeline, setTimeLine] = useState("");
  const [stateCapacity, setStateCapacity] = useState("");
  const [possessionLength, setPossessionLength] = useState("");
  const [developmentValue, setDevelopmentValue] = useState("");
  // const [fund,setFund] = useState("")
  const [fund, setFund] = useState("");
  const [selectedLandUse, setSelectedLandUse] = useState("");
  const [selectedDevelopment, setSelectedDevelopment] = useState("");
  const [allocationDate, setAllocationDate] = useState("");
  const [roless, setRoless] = useState([]);
  const [show, setShow] = useState(false);
  const [show50, setShow50] = useState(false);
  const [rows, setRows] = useState([{ description: "", file: "" }]);
  const [show20, setShow20] = useState(false);
  const [download, setDownload] = useState(false);
  const [showUploadTCC, setShowUploadTCC] = useState(false);
 const [searchTerm, setSearchTerm] = useState('');
  const fileInputRefs = useRef(null);
  const handleClose = () => setShow(false);
  const handleCloseTCC = () => setShowUploadTCC(false);
  const handleClose50 = () => setShow50(false);
  const handleClose20 = () => setShow20(false);
  const handleCloseAllocation = () => setShowAllocation(false);
  const handleCloseConfirmation = () => setShowConfirmation(false);
  const handleCloseRatification = () => setShowRatification(false);
  const handleCloseCFO = () => setShowCFO(false);
  const handleCloseScheme = () => setShowScheme(false);
  const handleCloseGovernor = () => setShowGovernor(false);
  const handleCloseLand = () => setShowLand(false);
  const handleCloseInfo = () => setShowInfo(false);
  const handleDownloadClose = () => setDownload(false);
  const handleShow = () => {
    setShow(true);
  };
  const handleShowTCC = () => {
    setShowUploadTCC(true);
  };
  const handleShow50 = () => {
    setShow50(true);
  };
  const handleShow20 = async () => {
    await fetchData1(foundInvoice);
    setShow20(true);
  };

  const handleConsent = (e) => {
    setSelectedConsent(e.target.value);
  };

  const [bearer, setBearer] = useState("");
  const [showGovernor, setShowGovernor] = useState(false);
  const [surveyorName, setSurveyorName] = useState("");
  const [surveyPlanNumber, setSurveyPlanNumber] = useState("");
  console.log(roless, "kh");
  const [landLocation, setLandLocation] = useState();
  const [name, setName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [clockTime, setClockTime] = useState(false);
  const [personal, setPersonal] = useState({});
  const [selectedFile3, setSelectedFile3] = useState("");
  const [paymentLoading, setPaymentLoading] = useState(false);
  const handleClockTime = () => {
    setClockTime(!clockTime);
  };
  const [showAlert, setShowAlert] = useState(false);
  const [showScheme, setShowScheme] = useState(false);
  const [caveatTypes, setCaveatTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [applicationModal1, setApplicationModal1] = useState(false);
  const [applicationModal2, setApplicationModal2] = useState(false);
  const [applicationModal3, setApplicationModal3] = useState(false);
  const [showSelectedDetailModal, setShowSelectedDetailModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [invoiceData,setInvoiceData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [isFilled, setIsFilled] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [foundInvoice, setFoundInvoice] = useState([]);
  const [foundInvoiceID, setFoundInvoiceID] = useState("");
  const navigate = useNavigate();
  const [totalCompleted, setTotalCompleted] = useState("");
  const [totalNotPaid, setTotalNotPaid] = useState("");
  const [totalApplications, setTotalApplications] = useState("");
  const [totalPending, setTotalPending] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [amount, setAmount] = useState("");
  const [showModal1, setShowModal1] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  const [balance, setBalance] = useState('');


  const formatDateForComparison = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };
  const filteredData = tableData.filter((item) => {
    const matchesDate = selectedDate
      ? formatDateForComparison(item.created_at) === selectedDate
      : true;
  
      const matchesSearch = searchTerm.trim()
      ? item?.description.toLowerCase().trim().includes(searchTerm.toLowerCase().trim())
      : true;
  
    return matchesDate && matchesSearch; // Both conditions must be met
  });
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
  const currentEntries1 = tableData1.slice(indexOfFirstEntry, indexOfLastEntry);
  const currentEntries2 = tableData2.slice(indexOfFirstEntry, indexOfLastEntry);
  const currentEntries3 = tableData3.slice(indexOfFirstEntry, indexOfLastEntry);
  const currentEntries4 = tableData4.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(tableData.length / entriesPerPage);
  const totalPages1 = Math.ceil(tableData1.length / entriesPerPage);
  const totalPages2 = Math.ceil(tableData2.length / entriesPerPage);
  const totalPages3 = Math.ceil(tableData3.length / entriesPerPage);
  const [benLoading, setBenLoading] = useState(false);
  const [visibleDropdown, setVisibleDropdown] = useState(null);
  // const [visibleMore, setVisibleMore] = useState(false);
  const dropdownRef = useRef(null);
  const [showOptions, setShowOptions] = useState(true);
  const [LGA, setLGA] = useState([]);
  

  const fetchCaveatTypes = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/all_caveat_type`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearer}`,
        },
      });

      const results = response.data?.data || [];
      setCaveatTypes(results);
      console.log(results);
    } catch (error) {
      console.error(error.response?.data?.message || "Error fetching data");
      setCaveatTypes([]);
    }
  };

  const fetchGovernorsType = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/all_governor_consent_type`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      const results = response.data?.data || [];
      setConsentTypes(results);
      console.log(results);
    } catch (error) {
      console.error(error.response?.data?.message || "Error fetching data");
      setConsentTypes([]);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchCaveatTypes();
      fetchGovernorsType();
    }
  }, [bearer]);

  const handleMoreClick = (id) => {
    setVisibleDropdown((prev) => (prev === id ? null : id));
  };

  const handleThirdModalClose = () => {
    setApplicationModal3(false);
    setApplicationModal1(false);
    setApplicationModal2(false);
    setSelectedOption(null);
    setIsConfirmed(false);
  };
  const handleSecondModalClose = () => {
    setApplicationModal3(false);
    setApplicationModal1(false);
    setApplicationModal2(false);
    setSelectedOption(null);
    setIsConfirmed(false);
  };
  const handleFirstModalClose = () => {
    setApplicationModal3(false);
    setApplicationModal1(false);
    setApplicationModal2(false);
    setSelectedOption(null);
    setIsConfirmed(false);
  };

  const handleOpenModal = () => setShowModal(true);
  const handleApplicationModal1 = () => {
    setApplicationModal1(true);
    setShowSelectedDetailModal(false);
  };
  const handleApplicationModal2 = () => {
    setApplicationModal2(true);
    setApplicationModal1(false);
  };
  const handleApplicationModal3 = () => {
    setApplicationModal3(true);
    setApplicationModal2(false);
  };

  const [isConfirmed, setIsConfirmed] = useState(false);
  const handleCloseApplicationModal1 = () => {
    setApplicationModal1(false);
    setShowSelectedDetailModal(true);
    setIsConfirmed(false);
  };
  const handleCloseApplicationModal2 = () => {
    setApplicationModal1(true);
    setApplicationModal2(false);
    setShowSelectedDetailModal(false);
    setIsConfirmed(false);
  };
  const handleCloseApplicationModal3 = () => {
    setApplicationModal2(true);
    setApplicationModal3(false);
    setShowSelectedDetailModal(false);
    setIsConfirmed(false);
  };
  const handleSelectedDetailModal = () => {
    setShowSelectedDetailModal(true);
    setShowModal(false);
  };
  const handleRadioClick = () => {
    setIsConfirmed(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOption(null);
  };

  const handleSourceFund = (e) => {
    setFund(e.target.value);
    // setShowErrorMessage(false);
  };

  const fetchTax = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/get_areas`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearer}`,
        },
      });

      const results = response.data?.data;
      // const resultsss = response.data?.data?.stations;
      setLGA(results);
      // setTableData1(resultsss);
      console.log(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        // navigate("/");
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setLGA([]);
      }
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchTax();
    }
  }, [bearer]);

  const handleAreaChange = (e) => {
    const selectedId = e.target.value;
    const areaName =
      tableData.find((item) => item.id.toString() === selectedId)
        ?.description || "";
    setSelectedArea(selectedId);
    setSelectedAreaName(areaName);
    console.log(areaName);
    if (selectedId) {
      fetchLocation(selectedId); // Fetch locations based on selected area
    }
  };

  useEffect(() => {
    const fetchSchemes = async () => {
      setRoleLoading(true);
      try {
        const response = await axios.get(
          `${BASE_URL}/customer/show_all_scheme`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${bearer}`,
            },
          }
        );
        const results = response.data?.data;
        setSchemes(results);
      } catch (error) {
        if (error.response && error.response.status === 401) {
        } else {
          const errorStatus = error.response?.data?.message;
          console.log(errorStatus);
          setSchemes([]);
        }
      } finally {
        setRoleLoading(false);
      }
    };
    fetchSchemes();
  }, [bearer]);

  const fetchAllLandUse = async () => {
    // setRoleLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all_land_use`, { headers });
      const results = response.data?.data;
      // console.log(results);
      setAllLands(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        // navigate("/");
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setAllLands([]);
      }
    } finally {
      // setRoleLoading(false);
    }
  };

  //  const fetchAllApplications = async () => {
  //     setRoleLoading(true);
  //     try {
  //       const response = await axios.get(`${BASE_URL}/fetch_all`, { headers });
  //       const results = response.data?.data;
  //       setAllApplications(results);
  //       console.log(results);
  //     } catch (error) {
  //       if (error.response && error.response.status === 401) {

  //       } else {
  //         const errorStatus = error.response?.data?.message;
  //         console.log(errorStatus);
  //         setAllApplications([]);
  //       }
  //     } finally {
  //       setRoleLoading(false);
  //     }
  //   };

  useEffect(() => {
    if (bearer) {
      fetchAllLandUse();
      // fetchAllApplications();
    }
  }, [bearer]);

  const handleGrantNature = (e) => {
    setSelectedNature(e.target.value);
    // setShowErrorMessage(false);
  };
  const fetchStatus = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all_land_status`, {
        headers,
      });
      const results = response.data?.data;
      setTableData32(results);
      console.log(results);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData32([]);
    } finally {
      setIsLoading(false);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(
      date.getMonth() + 1
    )}-${padZero(date.getDate())} `;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }

  const handleCloseSelectedDetailModal = () => {
    setShowModal(true);
    setShowSelectedDetailModal(false);
    setIsConfirmed(false);
  };
  const [selectedOption, setSelectedOption] = useState(null);

  const readData = async () => {
    try {
      const detail = await localStorage.getItem("userName");
      const details = await localStorage.getItem("token");

      if (detail !== null) {
        // const firstName = detail.split(' ')[0];
        setName(detail);
      }

      if (details !== null) {
        setBearer(details);
      }
    } catch (e) {
      alert("Failed to fetch the input from storage");
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const options = [
    "New Land Purchase/Allocation Application",
    "New Property Registration Programme Application",
    "New Home Owner's Charter (H.O.C) Application",
  ];

  const properties = [
    "LUD Site 1 , Ilaro",
    "Abeokuta Secretariat, Complex A",
    "Sagamu/Ogijo Road Acquisition",
    "New Town Acquisition",
    "Evergreen Estate, Adigbe/Obada-Oko Rd, Obada, Obafemi Owode LGA",
    "Lagos Univeristy Teaching Hospital, Along Lagos/Abeokuta Expresss Rd, Pakoto, Ifo LGA",
  ];

  // specify header
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${bearer}`,
  };


  const handleStationChange = (e) => {
    const selectedId = e.target.value;
    const stationName =
      tableData1.find((item) => item.id.toString() === selectedId)
        ?.description || "";
    setSelectedStationName(stationName);
    setSelectedStation(e.target.value);
    console.log(stationName);
    // setShowErrorMessage(false);
  };

  // useEffect(() => {
  //   if (bearer) {
  //     fetchallApplications();
  //   }
  // }, [bearer]);

  const handleOptionClick = (index) => {
    setSelectedOption(index);
  };

  const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

  const handleNewApplication = () => {
    navigate("/new_applications");
  };

  const [payment, setPayment] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [customerType, setCustomerType] = useState("");
  const [applicationDocs, setApplicationDocs] = useState([]);

  const fetchData1 = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/application_details`, {
        headers,
        params: { id },
      });
      const roleList = response.data?.data[0];
      const customer = response.data?.data[0]?.customer;
      const customerTyp = response.data?.data[0]?.customer?.user_type;
      const applicationdocs = response.data?.data[0]?.application_document;
      const payment = response.data?.data[0]?.payment;
      console.log(roleList, ".LLSKKS");
      console.log(payment);
      setCustomer(customer);
      setPayment(payment);
      setApplicationDocs(applicationdocs);
      setRoless(roleList);
      // console.log(roleList)
      setLandLocation(roleList.land_location);
      setAllocationDate(roless.allocation_date);
      setSelectedDevelopment(roless.land_development_status);
      setSelectedLandUse(roless.landuse_id);
      setTimeLine(roless.development_timeframe);
      setFund(roless.proposed_source_of_fund);
      setDevelopmentValue(roless.estimated_development_amount);
      setPossessionLength(roless.length_of_possession);
      setStateCapacity(roless.property_state);
      setValueProperty(roless.value_of_property);
      setPlotSize(roless.size_in_plot);
      setSqm(roless.size_in_sqm);
      console.log(roless.land_scheme);
      setSelectedLandStatus(roless.land_scheme);
      setTenant(roless.tenement_rate_number);
      setOtherProperty(roless.other_property_size);
      setProposedRBuilding(roless.proposed_residential_building);
      setCofONumber(roless.cofo_number);
      setCustomerType(customerTyp);
    } catch (error) {
      if (error.response && error.response.status === 401) {
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setRoless([]);
      }
    } finally {
      setIsLoading(false);
    }
  };
  const handleDevStatus = (e) => {
    setSelectedDevelopment(e.target.value);
    // setShowErrorMessage(false);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setRows(updatedRows);
  };

  const handleLandUse = (e) => {
    setSelectedLandUse(e.target.value);
    // setShowErrorMessage(false);
  };
  const handleProposedBuild = (e) => {
    setProposedRBuilding(e.target.value);
    // setShowErrorMessage(false);
  };

  const handleFileChange = (index, event) => {
    const file = event.target.files[0];
    if (file) {
      handleChange(index, "file", file);
    }
  };

  const handleAddRow = () => {
    setRows([...rows, { description: "", file: null }]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleLocationChanges = (e) => {
    const selectedId = e.target.value;
    // const stationName =
    //   tableData2.find((item) => item.id.toString() === selectedId)?.location ||
    //   "";
    // setSelectedLocationName(stationName);
    setLandLocation(e.target.value);
    // setShowErrorMessage(false);
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");

  const handleTccUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      if (file.type !== "application/pdf") {
        setError("Only PDF files are allowed.");
        setSelectedFile(null);
        event.target.value = ""; // Reset the file input
      } else {
        setSelectedFile(file);
        setError(""); // Clear error if valid
      }
    }
  };

  const openFileInModal = (fileUrl) => {
    if (fileUrl) {
      setSelectedFile3(fileUrl);
      setShowModal(true);
    } else {
      console.error("Invalid file URL");
      alert("File not available.");
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchData1();
    }
  }, [bearer]);

  const missingFields = [];
  if (!customer.tin) missingFields.push("Unverified STIN");
  if (customerType === "corporate") {
    if (!customer.cac) {
      missingFields.push("Unverified CAC");
    }
  } else if (customerType === "individual") {
    if (!customer.nin) {
      missingFields.push("Unverified NIN");
    }
  }

  if (!customer.tcc == 0)
    missingFields.push("No Verified Tax Clearance Certificate");

  const shouldShowAlert = missingFields.length > 0;

  const handleEyeClick = async (id, appType) => {
    console.log(appType);
    const foundInvoice = tableData.find((item) => item.id === id);
    setFoundInvoiceID(id);
    setFoundInvoice(foundInvoice);

    await fetchData1(id);

    // setShow20(true);
    if (appType === "Land Allocation") {
      console.log(roless);
      setShowAllocation(true);
    } else if (appType === "Confirmation") {
      console.log(roless);
      setShowConfirmation(true);
    } else if (appType === "Land Ratification") {
      setShowRatification(true);
    } else if (appType === "Certificate of Occupancy") {
      setShowCFO(true);
    } else if (appType === "Land Search") {
      setShowLand(true);
    } else if (appType === "Land Information") {
      setShowInfo(true);
    } else if (appType === "Governor's Consent") {
      setShowGovernor(true);
    } else if (appType === "Scheme Allocation") {
      setShowScheme(true);
    } else {
      setShow20(true);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value)
  }

  const exportToCSV = () => {
        if (tableData.length === 0) {
          alert("No data available for export.");
          return;
        }
      
        // Define CSV Headers
        const headers = ["S/N", "Payment Code", "Application Number", "Description", "Date", "Amount"];
      
        // Map the data to match CSV format
        const csvData = tableData.map((item, index) => ({
          "S/N": index +  1 || "N/A",
          "Payment Code": item.payment_code || "N/A",
          "Application Number": item.uuid || "N/A",
          "Description": item.description || "N/A",
          "Date": item.payment_date || "N/A",
          "Amount": item.amount || "N/A",
        }));
      
        // Convert to CSV format
        const csv = Papa.unparse({ fields: headers, data: csvData });
      
        // Create a Blob for download
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "Applications.csv");
      };
  

  const fetchLocation = async (areaId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/location_by_area?id=${areaId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      const resultsss = response.data?.data;
      setLocation2(resultsss);
      console.log(resultsss);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        // navigate("/");
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
        setLocation2([]); // Ensure this is set properly
      }
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchLocation();
    }
  }, [bearer]);

  useEffect(() => {
    if (roless && roless.land_scheme) {
      setSelectedLandStatus(roless.land_scheme);
    }
  }, [roless]);
  useEffect(() => {
    if (roless && roless.lga_of_land) {
      setSelectedArea(roless.lga_of_land);
    }
  }, [roless]);
  useEffect(() => {
    if (roless && roless.land_location) {
      setSelectedLocation(roless.land_location);
    }
  }, [roless]);
  useEffect(() => {
    if (roless && roless.landuse_id) {
      setSelectedLandUse(roless.landuse_id);
    }
  }, [roless]);
  useEffect(() => {
    if (roless && roless.proposed_residential_building) {
      setProposedRBuilding(roless.proposed_residential_building);
    }
  }, [roless]);
  useEffect(() => {
    if (roless && roless.size_in_sqm) {
      setSqm(roless.size_in_sqm);
    }
  }, [roless]);
  useEffect(() => {
    if (roless && roless.proposed_source_of_fund) {
      setFund(roless.proposed_source_of_fund);
    }
  }, [roless]);

  const { isDarkMode } = useTheme();

  const handleLandStatus = (e) => {
    setSelectedLandStatus(e.target.value);
    // setShowErrorMessage(false);
  };
  const handleDownloadClick = async (id) => {
    const foundInvoice = tableData.find((item) => item.id === id);
    console.log(foundInvoice);
    setFoundInvoiceID(id);
    setFoundInvoice(foundInvoice);
    await fetchData1(id);
    setDownload(true);
  };

  const handleEyeClick1 = async (id) => {
    const foundInvoice = tableData1.find((item) => item.id === id);
    setFoundInvoiceID(id);
    setFoundInvoice(foundInvoice);
    await fetchData1(id); // Pass the ID to fetchData1 and wait for it to complete
    setShow20(true);
  };
  const handleEyeClick2 = async (id) => {
    const foundInvoice = tableData2.find((item) => item.id === id);
    setFoundInvoiceID(id);
    setFoundInvoice(foundInvoice);
    await fetchData1(id); // Pass the ID to fetchData1 and wait for it to complete
    setShow20(true);
  };
  const handleEyeClick3 = async (id) => {
    const foundInvoice = tableData3.find((item) => item.id === id);
    setFoundInvoiceID(id);
    setFoundInvoice(foundInvoice);
    await fetchData1(id); // Pass the ID to fetchData1 and wait for it to complete
    setShow20(true);
  };

  const handleLocationChange = (e) => {
    const selectedId = e.target.value;
    const stationName =
      tableData2.find((item) => item.id.toString() === selectedId)?.location ||
      "";
    setSelectedLocationName(stationName);
    setSelectedLocation(e.target.value);
    // setShowErrorMessage(false);
  };

  const addNewDocument = async () => {
    setPaymentLoading(true);
    try {
      const formData = new FormData();

      rows.forEach((data, index) => {
        console.log(`File at index ${index}:`, data.file);

        if (data.file instanceof File) {
          formData.append(`document[${index}]`, data.file); // ✅ Send the actual file, not just the name
        } else {
          console.warn(`Invalid file at index ${index}:`, data.file);
        }

        formData.append(`description[${index}]`, data.description);
      });

      formData.append("application_id", roless.id);

      const response = await axios.post(`${BASE_URL}/add-documents`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${bearer}`,
        },
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

      setRows([{ description: "", file: "" }]);
      handleClose();
      fetchData1();
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (error.response?.data?.message) {
        errorMessage =
          typeof error.response.data.message === "string"
            ? error.response.data.message
            : JSON.stringify(error.response.data.message);

        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
      }
    } finally {
      setPaymentLoading(false);
    }
  };

  const handleUploadTcc = async () => {
    setPaymentLoading(true);
    try {
      const formData = new FormData();

      formData.append("tcc", selectedFile);

      const response = await axios.post(
        `${BASE_URL}/customer/upload_tcc`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });

      handleCloseTCC();
      handleClose20();
      // fetchallApplications();
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";

      if (error.response?.data?.message) {
        errorMessage =
          typeof error.response.data.message === "string"
            ? error.response.data.message
            : JSON.stringify(error.response.data.message);

        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMessage,
        });
      }
    } finally {
      setPaymentLoading(false);
    }
  };

  const handleAssessmentClick = (id) => {
    const foundReceipt = tableData.find((item) => item.id === id);
    if (foundReceipt) {
      const foundPayment = foundReceipt.payment[0];

      if (foundReceipt.service?.name === "Land Ratification") {
        navigate("/letter_of_assessment", { state: { foundPayment } });
      } else if (foundReceipt.service?.name === "Land Allocation") {
        navigate("/land_allocation_letter", { state: { foundPayment } });
      }

      setEyeClicked(true);
    }
  };

  const toSentenceCase = (name) => {
    if (!name) return "";

    // Check if the name is already in sentence case
    const isSentenceCase = name
      .split(" ")
      .every(
        (word) =>
          word.charAt(0) === word.charAt(0).toUpperCase() &&
          word.slice(1) === word.slice(1).toLowerCase()
      );

    if (isSentenceCase) {
      return name;
    }

    // Convert to sentence case
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleEyeClick5= (id) => {
    const foundUser = tableData.find((item) => item.id === id);
    // const foundApps = applicationDet.find((item) => item.id === id);

    if (foundUser) {
      navigate('/view_invoices', { state: { userData: foundUser } });
    }
  };


  const fetchDashboardData = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/invoices`, {
        headers,
      });
      console.log(response);
      const results = response.data?.data;
      const balance = response.data?.data[0]?.amount;
      setBalance(balance);
      console.log(response?.data?.data);
      setTableData(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // navigate('/applications');
      } else {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            // toast.error(errorMessage)
            console.log(errorMessage);
          }
        }
        setTableData([]);
      }
    } finally {
      setBenLoading(false);
    }
  };


  const fetchDashboardData4 = async () => {
    setBenLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/all_invoices`, {
        headers,
      });
      console.log(response);
      const results = response.data?.data;
      const balance = response.data?.data[0]?.amount;
      // setBalance(balance);
      console.log(response?.data?.data);
      setTableData4(results);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // navigate('/applications');
      } else {
        let errorMessage = "An error occurred. Please try again.";
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          if (typeof error.response.data.message === "string") {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join("; ");
          } else if (typeof error.response.data.message === "object") {
            // toast.error(errorMessage)
            console.log(errorMessage);
          }
        }
        setTableData4([]);
      }
    } finally {
      setBenLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchDashboardData();
      fetchDashboardData4();
    }
  }, [bearer]);

   const handleVerifyPayment = async (transaction_id) => {
    setCreateLoading(true);
  
    // Show loading Swal before request
    Swal.fire({
      title: 'Verifying...',
      text: 'Please wait while we verify your payment.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        title: classes.myTitle,
        popup: classes.myText,
      },
    });
  
    try {
      const formData = new FormData();
      formData.append("transaction_id", transaction_id);
  
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${bearer}`,
      };
  
      const response = await axios.post(
        `${BASE_URL}/validate-payment`,
        formData,
        { headers }
      );
  
      Swal.fire({
        imageUrl: verified,
        title: 'Success!',
        text: response.data.message,
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
      });

      fetchDashboardData();
  
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
  fetchDashboardData();
      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: errorMessage,
        customClass: {
          title: classes.myTitle,
          popup: classes.myText,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
      });
  
    } finally {
      setCreateLoading(false);
    }
  };

  const handleAmount = async () => {
    setPayLoading(true);
    try {  
      const response = await axios.post(
       `${BASE_URL}/customer/make_payment`,
      {
        amount: amount
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${bearer}`,
        },
      }
    );
    setPayLoading(false);
    const responseData = response.data;
    const paymentData = response.data?.data;
    navigate("/invoice_detail", { state: { paymentData } });

      console.log(response.data, "fullpayment");  
      console.log(paymentData, "full payment"); 
      // Swal.fire({
      //   icon: "success",
      //   title: "Successful",
      //   text: response.message,
      // });
      

    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: JSON.stringify(error.response.data.message),
        });
      }
      setPayLoading(false);
    } finally {
      setPayLoading(false);
      setShowModal1(false); 
    }
  };
  const handleSubmit = () => {
    handleAmount(); 
  };

  return (
    <>
      <div className={classes.appcontainer}>
        <div className={classes.sidenav}>
          <Navbar expand="lg" className={`d-none d-md-block ${classes.navbar}`}>
            <Container fluid></Container>
          </Navbar>
          <Navbar
            bg="light"
            expand={false}
            className={`d-md-none ${classes.bglight}`}
          >
            <Container fluid>
              <Button
                style={{ backgroundColor: "#21B55A", border: "none" }}
                variant="success"
                onClick={handleShow}
              >
                ☰
              </Button>
            </Container>
          </Navbar>
          <DashboardNav show={show} handleClose={handleClose} />
        </div>

        <div className={classes.maincontent}>
          <div className={classes.mobileHeader}>
            <Horheader />
          </div>
          <div className={classes.dashBoardCont}>
          <Modal show={showModal1} 
         onHide={() => {
            setShowModal1(false);
            setShowOptions(true);
          }} 
          centered>
        <Modal.Header style={{borderBottom: 'none'}} closeButton>
        <img src={OgsLogos} alt="OGSWC" style={{height: 50, objectFit: 'contain'}} />
        </Modal.Header>
      <Modal.Body className="text-center">
        <div
          style={{
            border: "1px solid #ccc",
            padding: "10px",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          <div style={{ fontWeight: "bold" }}>Outstanding Balance</div>
          <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}> #{parseFloat(balance).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</div>
        </div>

        {/* Form */}
        <Form>
        {/* <Col md={12}> */}
        <Col md={12}>
          <CurrencyInput
            style={{height: 44, marginTop: -10}}
            id={`amount`}
            name="amount"
            value={amount}
            decimalsLimit={2}
            onValueChange={(value) => setAmount(value, "amount", value)}
            groupSeparator=","
            placeholder="Enter Amount"
            className="form-control"
            prefix="₦"
            />
                            </Col>                        
        </Form>

     
        <Button
          style={{width: "100%"}}
          className="mt-3"
          onClick={handleSubmit}
          disabled={!amount || parseFloat(amount) <= 0}
        >
           {payLoading ? (
                <>
                <Spinner size="sm" />
                  <span style={{marginLeft: 5}}>Please wait...</span>
                  </>
                   ) : (
                      "Submit"
                   )}  
        </Button>
      </Modal.Body>
    </Modal>



            <div className={classes.usrwlcm}>
              <div>
                <p className={classes.wlcm}>Invoices</p>
                <p style={{marginTop: -20, }}>View, Track, and Manage all bills to be paid.</p>
              </div>
            </div>
        
            {/* <div>
              <div className={classes.allcards}>
                {" "}
                <div className={classes.card}>
                  <div className={classes.cardContent}>
                    <h4 className={classes.title}>Overall Amount Requested</h4>
                    <p className={classes.amount}>
                      ₦{"000,000,00"}
                      <span className={classes.litnmbr}>.00</span>
                    </p>
                    <span className={classes.percentage}>▲ 00%</span>
                  </div>

                 
                </div>
                <div className={classes.card}>
                  <div className={classes.cardContent}>
                    <h4 className={classes.title}>Total Amount Approved</h4>
                    <p className={classes.amount}>
                      ₦{"000,000,00"}
                      <span className={classes.litnmbr}>.00</span>
                    </p>
                    <span className={classes.percentage}>▲ 00%</span>
                  </div>

              
                </div>
                <div className={classes.card}>
                  <div className={classes.cardContent}>
                    <h4 className={classes.title}>Total Amount Utilized</h4>
                    <p className={classes.amount}>
                      ₦{"000,000,00"}
                      <span className={classes.litnmbr}>.00</span>
                    </p>
                    <span className={classes.percentage}>▲ 00%</span>
                  </div>

                 
                </div>
              </div>
            </div> */}

            <div
              className={
                isDarkMode
                  ? classes.applicationHistory1
                  : classes.applicationHistory
              }
            >
               <Tabs
                defaultActiveKey="pending_payment"
                id="uncontrolled-tab-example"
                className={`mb-3 complete-tabs ${classes.tabSet}`}
                variant="underline"
                color="#21B55A"
                style={{
                  width: "100%",
                  paddingLeft: 30,
                  paddingTop: 5,
                  height: 50,
                  borderRadius: 8,
                  backgroundColor: "#F5F5F5",
                }}
              >
                
                <Tab eventKey="pending_payment" title="Pending Payment">

                  
              <div className={classes.hortrstns}>
                <h1 className={classes.recenttrsd}></h1>
                <div className={classes.midDiv}>
                  <div className={classes.divSearch}>
                    <img
                      src={search}
                      alt="search"
                      className={classes.searchIcon}
                    />
                   <input
                                     value={searchTerm}
                                       type="text"
                                       placeholder="Search"
                                       className={classes.search}
                                       onChange={(e) => {
                                         setSearchTerm(e.target.value);
                                       }}
                                       
                                     />
                                     {searchTerm && (
                         <button 
                           onClick={() => setSearchTerm('')}
                           style={{
                             position: 'absolute',
                             right: '10px',
                             top: '50%',
                             transform: 'translateY(-50%)',
                             background: 'none',
                             border: 'none',
                             cursor: 'pointer',
                             color: '#000'
                           }}
                         >
                           ×
                         </button>
                         )}
                  </div>
                 

                  <input 
                    type="date" 
                    className={classes.bttens} 
                    onChange={handleDateChange} name="date" value={selectedDate}
                  />

                  <label
                    style={{
                      fontSize: 14,
                      color: " #828282",
                      fontWeight: 600,
                      gap: 10,
                      borderRadius: 8,
                      // backgroundColor: '#F2F2F2',
                      marginLeft: 10,
                    }}
                  >
                    <div className={classes.divBtn}>
                                        <div className={classes.divOne}>
                                          <div onClick={exportToCSV} className={classes.stIC}>
                                            <p className={classes.stN} sty>Export CSV</p>
                                            <img src={xport} alt="status" className={classes.filter} />
                                          </div>
                                        </div>
                                      </div>
                  </label>
                </div>
              </div>

              <div className={classes.mainTables}>
                {benLoading ? (
                  <>
                    <Placeholder xs={6} />
                    <Placeholder className="w-75" />{" "}
                    <Placeholder classes={{ width: "25%" }} />
                  </>
                ) : tableData?.length === 0 ? (
                  <div className={classes.notFound}>
                    <img src={notransaction} alt="not-found" />
                    <p>No Invoice found</p>
                  </div>
                ) : (
                  <div>
                    <table style={{ width: "98%" }}>
                      <thead style={{ whiteSpace: "nowrap", width: "100%", backgroundColor: 'rgb(237, 236, 236)'}}>
                      <tr>
                            <th style={{ color: isDarkMode && "white" }}>
                              S/N
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                             Account Number
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                            Bill Number
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                              Description
                            </th>
                           
                            <th style={{ color: isDarkMode && "white" }}>
                              Bill Date
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                              Amount
                            </th>
                            <th></th>
                          </tr>
                      </thead>

                      <tbody style={{ whiteSpace: "wrap",  }}>
                        {currentEntries?.map((rowId, index) => (
                          <tr
                            key={rowId}
                            style={{
                              backgroundColor:
                                index % 2 !== 0
                                  ? "rgb(237, 236, 236)"
                                  : "transparent",
                            }}
                          >
                            <td style={{ padding: 10 }}>{index + 1}</td>
                            <td style={{ padding: 10 }}>
                              {rowId?.account_number}
                            </td>
                            <td style={{ padding: 10 }}>{rowId.bill_number}</td>
                            
                            <td style={{ padding: 10 }}>
                              {rowId?.description}
                            </td>
                            <td style={{ padding: 10 }}>
                              {formatDate(rowId.created_at)}
                            </td>
                            <td style={{ padding: 10, color: isDarkMode ? "#ffffff" : "#333333", fontWeight: 500 }}>₦{parseFloat(rowId.amount).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}</td>
                           
                            
                            {/* <td style={{ padding: 10 }}>₦528,861.00</td> */}
                            <td
                              style={{ padding: 10 }}
                              className={classes.moreTxt}
                            >
                              <div
                                style={{ position: "relative" }}
                                className={classes.menuWeb}
                              >
                                <img
                                  className={classes.moreIcon}
                                  src={MoreIcon}
                                  alt="more"
                                  onClick={() => handleMoreClick(rowId)}
                                  style={{ cursor: "pointer" }}
                                />
                                {visibleDropdown === rowId && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      right: 0,
                                      backgroundColor: "white",
                                      zIndex: 9999,
                                      boxShadow:
                                        "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                      borderRadius: "4px",
                                    }}
                                  >
                {showOptions && (
  <>
    {/* Make Payment option */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
        cursor: "pointer",
        textAlign: "left",
        whiteSpace: "nowrap",
      }}
      onClick={() => {
        setShowModal1(true);
        setShowOptions(false); // Hide both options
      }}
    >
      <img
        src={Printer}
        alt="invoice"
        style={{
          width: "20px",
          marginRight: "10px",
        }}
      />
      Make Payment
    </div>

    {/* Validate Payment option */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
        cursor: "pointer",
        textAlign: "left",
        whiteSpace: "nowrap",
      }}
      onClick={() => handleVerifyPayment(rowId.transaction_id)}
    >
      <LiaCheckCircle
        size={20}
        style={{
          color: "#828282",
          marginRight: 10,
        }}
      />
      Validate Payment
    </div>
  </>
)}

                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className={classes.mobileView}>
                <div className={classes.mainTable}>
                  {benLoading ? (
                    <p>Loading data, Please wait...</p>
                  ) : (
                    <div
                      className={classes.tableCon}
                      style={{
                        overflowX: "auto", // Horizontal scroll for table
                        whiteSpace: "nowrap", // Prevent table from wrapping
                        maxWidth: "100%", // Limit container width to screen size
                      }}
                    >
                      <table
                        className="table display table-hover m-0 card-table"
                        style={{
                          minWidth: "600px", // Minimum table width to ensure visibility
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ color: isDarkMode && "white" }}>
                              S/N
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                            Account Number
                            </th>
                            {/* <th style={{ color: isDarkMode && "white" }}>
                              Bill Number
                            </th> */}
                            <th style={{ color: isDarkMode && "white" }}>
                              Description
                            </th>
                           
                            <th style={{ color: isDarkMode && "white" }}>
                              Transaction Date
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                              Amount
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody style={{ whiteSpace: "wrap" }}>
                        {currentEntries?.map((rowId, index) => (
                          <tr
                            key={rowId}
                            style={{
                              backgroundColor:
                                index % 2 !== 0
                                  ? "rgba(30, 165, 82, 0.1)"
                                  : "transparent",
                            }}
                          >
                            <td style={{ padding: 10 }}>{index + 1}</td>
                            <td style={{ padding: 10 }}>
                              {rowId?.account_number}
                            </td>
                            {/* <td style={{ padding: 10 }}>{rowId.bill_number}</td> */}
                            
                            <td style={{ padding: 10 }}>
                              {rowId?.description}
                            </td>
                            <td style={{ padding: 10 }}>
                              {formatDate(rowId.created_at)}
                            </td>
                            <td style={{ padding: 10, color: isDarkMode ? "#ffffff" : "#333333", fontWeight: 500 }}>₦{parseFloat(rowId.amount).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}</td>
                           
                            
                            {/* <td style={{ padding: 10 }}>₦528,861.00</td> */}
                            <td
                              style={{ padding: 10 }}
                              className={classes.moreTxt}
                            >
                              <div
                                style={{ position: "relative" }}
                                className={classes.menuWeb}
                              >
                                <img
                                  className={classes.moreIcon}
                                  src={MoreIcon}
                                  alt="more"
                                  onClick={() => handleMoreClick(rowId)}
                                  style={{ cursor: "pointer" }}
                                />
                                {visibleDropdown === rowId && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      right: 0,
                                      backgroundColor: "white",
                                      zIndex: 9999,
                                      boxShadow:
                                        "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                      }}
                                      onClick={() => handleEyeClick5(rowId.id)}
                                    >
                                      <img
                                        src={Printer}
                                        alt="invoice"
                                        style={{
                                          width: "20px",
                                          marginRight: "10px",
                                        }}
                                      />
                                      Make Payment
                                    </div>
                                    <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "5px 10px",
              cursor: "pointer",
              textAlign: "left",
                                        whiteSpace: "nowrap",
            }}
            onClick={() => handleVerifyPayment(rowId.transaction_id)}
          >
          
              <LiaCheckCircle
                                                size={20}
                                                style={{
                                                  color: "#828282",
                                                  marginRight: 10,
                                                }}
                                              />
            
              Validate Payment
          
          </div>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
               {!benLoading && (
                              <div className={classes.endded}>
                                <div className={classes.showTxt}>
                                  <div className={classes.show}>
                                    <label style={{
                                      fontSize: 14,
                                      color: isDarkMode ? '#ffffff' : '#333333',
                                      fontWeight: 600,
                                      gap: 10
                                    }} className="d-flex justify-content-start align-items-center">
                                      Showing
                                      <Form.Select style={{ width: 114, height: 44, borderRadius: 8, fontSize: 14, fontWeight: 600 }} name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" className="custom-select custom-select-sm form-control form-control-sm"
                                        value={entriesPerPage}
                                        onChange={(e) => {
                                          setEntriesPerPage(parseInt(e.target.value));
                                          setCurrentPage(1);
                                        }}
                                      >
                                        <option value={10} >10 entries</option>
                                        <option value={25} >25 entries</option>
                                        <option value={50} >50 entries</option>
                                        <option value={100} >100 entries</option>
                                      </Form.Select>
                                    </label>
                                  </div>
                                </div>
              
                                <div className={classes.btmPagination}>
                                      <div style={{ display: "flex" }}>
                                        <button
                                          style={{
                                            textAlign: "center",
                                            border: "1px solid #F1F1F1",
                                            backgroundColor: "#fff",
                                            borderRadius: 8,
                                            height: "32px",
                                            width: "32px",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: "#000000",
                                            cursor: "pointer",
                                          }}
                                          onClick={handlePrevPage}
                                          disabled={currentPage === 1}
                                        >
                                          {"<"}
                                        </button>
                                        {[...Array(totalPages)].map((_, page) => {
                                          // Show only 5 pages or less if available
                                          if (
                                            page < 3 ||
                                            page === currentPage - 1 ||
                                            page === totalPages - 1
                                          ) {
                                            return (
                                              <button
                                                key={page + 1}
                                                style={{
                                                  textAlign: "center",
                                                  marginLeft: "0.4rem",
                                                  marginRight: "0.4rem",
                                                  fontSize: "14px",
                                                  fontWeight: 700,
                                                  color:
                                                    page + 1 === currentPage
                                                      ? "#ffffff"
                                                      : "#333333",
                                                  backgroundColor:
                                                    page + 1 === currentPage
                                                      ? "#55AEFE"
                                                      : "#fff",
                                                  height: "32px",
                                                  borderRadius: "8px",
                                                  //   padding: '0.5rem',
                                                  border: "1px solid #F1F1F1",
                                                  width: "32px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => setCurrentPage(page + 1)}
                                              >
                                                {page + 1}
                                              </button>
                                            );
                                          }
                                          return null;
                                        })}
                                        <button
                                          style={{
                                            textAlign: "center",
                                            border: "1px solid #F1F1F1",
                                            backgroundColor: "#fff",
                                            borderRadius: 8,
                                            height: "32px",
                                            width: "32px",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: "#000000",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleNextPage}
                                          disabled={currentPage === totalPages}
                                        >
                                          {">"}
                                        </button>
                                      </div>
                                    </div>
              
                              </div>
                            )}


                </Tab>


                <Tab eventKey="Generate Bill" title="Generated Bill">
                    
              <div className={classes.hortrstns}>
                <h1 className={classes.recenttrsd}></h1>
                <div className={classes.midDiv}>
                  <div className={classes.divSearch}>
                    <img
                      src={search}
                      alt="search"
                      className={classes.searchIcon}
                    />
                   <input
                                     value={searchTerm}
                                       type="text"
                                       placeholder="Search"
                                       className={classes.search}
                                       onChange={(e) => {
                                         setSearchTerm(e.target.value);
                                       }}
                                       
                                     />
                                     {searchTerm && (
                         <button 
                           onClick={() => setSearchTerm('')}
                           style={{
                             position: 'absolute',
                             right: '10px',
                             top: '50%',
                             transform: 'translateY(-50%)',
                             background: 'none',
                             border: 'none',
                             cursor: 'pointer',
                             color: '#000'
                           }}
                         >
                           ×
                         </button>
                         )}
                  </div>
                 

                  <input 
                    type="date" 
                    className={classes.bttens} 
                    onChange={handleDateChange} name="date" value={selectedDate}
                  />

                  <label
                    style={{
                      fontSize: 14,
                      color: " #828282",
                      fontWeight: 600,
                      gap: 10,
                      borderRadius: 8,
                      // backgroundColor: '#F2F2F2',
                      marginLeft: 10,
                    }}
                  >
                    <div className={classes.divBtn}>
                                        <div className={classes.divOne}>
                                          <div onClick={exportToCSV} className={classes.stIC}>
                                            <p className={classes.stN} sty>Export CSV</p>
                                            <img src={xport} alt="status" className={classes.filter} />
                                          </div>
                                        </div>
                                      </div>
                  </label>
                </div>
              </div>

              <div className={classes.mainTables}>
                {benLoading ? (
                  <>
                    <Placeholder xs={6} />
                    <Placeholder className="w-75" />{" "}
                    <Placeholder classes={{ width: "25%" }} />
                  </>
                ) : tableData4?.length === 0 ? (
                  <div className={classes.notFound}>
                    <img src={notransaction} alt="not-found" />
                    <p>No Invoice found</p>
                  </div>
                ) : (
                  <div>
                    <table style={{ width: "98%" }}>
                      <thead style={{ whiteSpace: "nowrap", width: "100%", backgroundColor: 'rgb(237, 236, 236)'}}>
                      <tr>
                            <th style={{ color: isDarkMode && "white" }}>
                              S/N
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                             Account Number
                            </th>
                            {/* <th style={{ color: isDarkMode && "white" }}>
                            Bill Number
                            </th> */}
                            <th style={{ color: isDarkMode && "white" }}>
                              Description
                            </th>
                           
                            <th style={{ color: isDarkMode && "white" }}>
                              Bill Date
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                              Amount
                            </th>
                            <th></th>
                          </tr>
                      </thead>

                      <tbody style={{ whiteSpace: "wrap",  }}>
                        {currentEntries4?.map((rowId, index) => (
                          <tr
                            key={rowId}
                            style={{
                              backgroundColor:
                                index % 2 !== 0
                                  ? "rgb(237, 236, 236)"
                                  : "transparent",
                            }}
                          >
                            <td style={{ padding: 10 }}>{index + 1}</td>
                            <td style={{ padding: 10 }}>
                              {rowId?.account_number}
                            </td>
                            {/* <td style={{ padding: 10 }}>{rowId.bill_number}</td> */}
                            
                            <td style={{ padding: 10 }}>
                              {rowId?.description}
                            </td>
                            <td style={{ padding: 10 }}>
                              {formatDate(rowId.created_at)}
                            </td>
                            <td style={{ padding: 10, color: isDarkMode ? "#ffffff" : "#333333", fontWeight: 500 }}>₦{parseFloat(rowId.amount).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}</td>
                           
                            
                            {/* <td style={{ padding: 10 }}>₦528,861.00</td> */}
                            <td
                              style={{ padding: 10 }}
                              className={classes.moreTxt}
                            >
                              <div
                                style={{ position: "relative" }}
                                className={classes.menuWeb}
                              >
                                <img
                                  className={classes.moreIcon}
                                  src={MoreIcon}
                                  alt="more"
                                  onClick={() => handleMoreClick(rowId)}
                                  style={{ cursor: "pointer" }}
                                />
                                {visibleDropdown === rowId && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      right: 0,
                                      backgroundColor: "white",
                                      zIndex: 9999,
                                      boxShadow:
                                        "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                      }}
                                      onClick={() => handleEyeClick5(rowId.id)}
                                    >
                                      <img
                                        src={Printer}
                                        alt="invoice"
                                        style={{
                                          width: "20px",
                                          marginRight: "10px",
                                        }}
                                      />
                                      View Invoice
                                    </div>
                                    <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "5px 10px",
              cursor: "pointer",
              textAlign: "left",
                                        whiteSpace: "nowrap",
            }}
            onClick={() => handleVerifyPayment(rowId.transaction_id)}
          >
          
              <LiaCheckCircle
                                                size={20}
                                                style={{
                                                  color: "#828282",
                                                  marginRight: 10,
                                                }}
                                              />
            
              Validate Payment
          
          </div>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              <div className={classes.mobileView}>
                <div className={classes.mainTable}>
                  {benLoading ? (
                    <p>Loading data, Please wait...</p>
                  ) : (
                    <div
                      className={classes.tableCon}
                      style={{
                        overflowX: "auto", // Horizontal scroll for table
                        whiteSpace: "nowrap", // Prevent table from wrapping
                        maxWidth: "100%", // Limit container width to screen size
                      }}
                    >
                      <table
                        className="table display table-hover m-0 card-table"
                        style={{
                          minWidth: "600px", // Minimum table width to ensure visibility
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ color: isDarkMode && "white" }}>
                              S/N
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                            Account Number
                            </th>
                            {/* <th style={{ color: isDarkMode && "white" }}>
                              Bill Number
                            </th> */}
                            <th style={{ color: isDarkMode && "white" }}>
                              Description
                            </th>
                           
                            <th style={{ color: isDarkMode && "white" }}>
                              Transaction Date
                            </th>
                            <th style={{ color: isDarkMode && "white" }}>
                              Amount
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody style={{ whiteSpace: "wrap" }}>
                        {currentEntries?.map((rowId, index) => (
                          <tr
                            key={rowId}
                            style={{
                              backgroundColor:
                                index % 2 !== 0
                                  ? "rgba(30, 165, 82, 0.1)"
                                  : "transparent",
                            }}
                          >
                            <td style={{ padding: 10 }}>{index + 1}</td>
                            <td style={{ padding: 10 }}>
                              {rowId?.account_number}
                            </td>
                            {/* <td style={{ padding: 10 }}>{rowId.bill_number}</td> */}
                            
                            <td style={{ padding: 10 }}>
                              {rowId?.description}
                            </td>
                            <td style={{ padding: 10 }}>
                              {formatDate(rowId.created_at)}
                            </td>
                            <td style={{ padding: 10, color: isDarkMode ? "#ffffff" : "#333333", fontWeight: 500 }}>₦{parseFloat(rowId.amount).toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}</td>
                           
                            
                            {/* <td style={{ padding: 10 }}>₦528,861.00</td> */}
                            <td
                              style={{ padding: 10 }}
                              className={classes.moreTxt}
                            >
                              <div
                                style={{ position: "relative" }}
                                className={classes.menuWeb}
                              >
                                <img
                                  className={classes.moreIcon}
                                  src={MoreIcon}
                                  alt="more"
                                  onClick={() => handleMoreClick(rowId)}
                                  style={{ cursor: "pointer" }}
                                />
                                {visibleDropdown === rowId && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      right: 0,
                                      backgroundColor: "white",
                                      zIndex: 9999,
                                      boxShadow:
                                        "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                      borderRadius: "4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                        textAlign: "left",
                                        whiteSpace: "nowrap",
                                      }}
                                      onClick={() => handleEyeClick5(rowId.id)}
                                    >
                                      <img
                                        src={Printer}
                                        alt="invoice"
                                        style={{
                                          width: "20px",
                                          marginRight: "10px",
                                        }}
                                      />
                                      View Invoice
                                    </div>
                                    <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "5px 10px",
              cursor: "pointer",
              textAlign: "left",
                                        whiteSpace: "nowrap",
            }}
            onClick={() => handleVerifyPayment(rowId.transaction_id)}
          >
          
              <LiaCheckCircle
                                                size={20}
                                                style={{
                                                  color: "#828282",
                                                  marginRight: 10,
                                                }}
                                              />
            
              Validate Payment
          
          </div>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
               {!benLoading && (
                              <div className={classes.endded}>
                                <div className={classes.showTxt}>
                                  <div className={classes.show}>
                                    <label style={{
                                      fontSize: 14,
                                      color: isDarkMode ? '#ffffff' : '#333333',
                                      fontWeight: 600,
                                      gap: 10
                                    }} className="d-flex justify-content-start align-items-center">
                                      Showing
                                      <Form.Select style={{ width: 114, height: 44, borderRadius: 8, fontSize: 14, fontWeight: 600 }} name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" className="custom-select custom-select-sm form-control form-control-sm"
                                        value={entriesPerPage}
                                        onChange={(e) => {
                                          setEntriesPerPage(parseInt(e.target.value));
                                          setCurrentPage(1);
                                        }}
                                      >
                                        <option value={10} >10 entries</option>
                                        <option value={25} >25 entries</option>
                                        <option value={50} >50 entries</option>
                                        <option value={100} >100 entries</option>
                                      </Form.Select>
                                    </label>
                                  </div>
                                </div>
              
                                <div className={classes.btmPagination}>
                                      <div style={{ display: "flex" }}>
                                        <button
                                          style={{
                                            textAlign: "center",
                                            border: "1px solid #F1F1F1",
                                            backgroundColor: "#fff",
                                            borderRadius: 8,
                                            height: "32px",
                                            width: "32px",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: "#000000",
                                            cursor: "pointer",
                                          }}
                                          onClick={handlePrevPage}
                                          disabled={currentPage === 1}
                                        >
                                          {"<"}
                                        </button>
                                        {[...Array(totalPages)].map((_, page) => {
                                          // Show only 5 pages or less if available
                                          if (
                                            page < 3 ||
                                            page === currentPage - 1 ||
                                            page === totalPages - 1
                                          ) {
                                            return (
                                              <button
                                                key={page + 1}
                                                style={{
                                                  textAlign: "center",
                                                  marginLeft: "0.4rem",
                                                  marginRight: "0.4rem",
                                                  fontSize: "14px",
                                                  fontWeight: 700,
                                                  color:
                                                    page + 1 === currentPage
                                                      ? "#ffffff"
                                                      : "#333333",
                                                  backgroundColor:
                                                    page + 1 === currentPage
                                                      ? "#55AEFE"
                                                      : "#fff",
                                                  height: "32px",
                                                  borderRadius: "8px",
                                                  //   padding: '0.5rem',
                                                  border: "1px solid #F1F1F1",
                                                  width: "32px",
                                                  cursor: "pointer",
                                                }}
                                                onClick={() => setCurrentPage(page + 1)}
                                              >
                                                {page + 1}
                                              </button>
                                            );
                                          }
                                          return null;
                                        })}
                                        <button
                                          style={{
                                            textAlign: "center",
                                            border: "1px solid #F1F1F1",
                                            backgroundColor: "#fff",
                                            borderRadius: 8,
                                            height: "32px",
                                            width: "32px",
                                            fontWeight: 700,
                                            fontSize: 14,
                                            color: "#000000",
                                            cursor: "pointer",
                                          }}
                                          onClick={handleNextPage}
                                          disabled={currentPage === totalPages}
                                        >
                                          {">"}
                                        </button>
                                      </div>
                                    </div>
              
                              </div>
                            )}

                </Tab>
                
                </Tabs>


              
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Allinvoices;
